import * as React from "react";
import EmptyState from "./global/EmptyState";

const NoResultsOverlay = () => {
  return <EmptyState type="noResults" message="No results found" />;
};
export default NoResultsOverlay;
